import React from 'react';
import HPPress from './HPPress';

const View = () => <HPPress />;

export default View;